require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/_core').Object.getPrototypeOf;



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/node_modules/core-js/library/fn/object/get-prototype-of.js
// module id = 1666
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 13 20 21